import { PortalUserApiResponse, PortalUserCreate } from '@ravago/shared/page-data/models/elements';

export class PortalUsersUtils {
  static async addPortalUser(body: PortalUserCreate): Promise<PortalUserApiResponse> {
    return fetch(`/api/portal-users`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(async (res) => {
        const json = (await res.json()) as PortalUserApiResponse;

        return json;
      })
      .catch(() => ({ success: false }));
  }

  static async deactivatePortalUser(userId: string): Promise<PortalUserApiResponse> {
    return fetch(`/api/portal-users/${userId}/deactivate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(async (res) => {
        const json = (await res.json()) as PortalUserApiResponse;

        return json;
      })
      .catch(() => ({ success: false }));
  }

  static async deletePortalUser(userId: string): Promise<PortalUserApiResponse> {
    return fetch(`/api/portal-users/${userId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(async (res) => {
        const json = (await res.json()) as PortalUserApiResponse;

        return json;
      })
      .catch(() => ({ success: false }));
  }
}
